'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignatureIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var SignatureIcon = function SignatureIcon(_ref) {
  var color = _ref.color,
      _ref$fillColor = _ref.fillColor,
      fillColor = _ref$fillColor === undefined ? 'transparent' : _ref$fillColor,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ['color', 'fillColor', 'height', 'width']);

  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 24 24',
    width: width,
    height: height
  }, props), _react2.default.createElement('path', {
    d: 'M10.08 15.19h2.26l8.38-8.38-2.22-2.26-8.38 8.38z',
    fill: fillColor,
    transform: 'translate(0.5, 0.5)'
  }), _react2.default.createElement('path', {
    d: 'M13.15 17.19H9.83a.76.76 0 0 1-.75-.75v-3.32a.75.75 0 0 1 .22-.53l9.13-9.13a.74.74 0 0 1 1.06 0l3.32 3.32a.75.75 0 0 1 0 1.06L13.68 17a.75.75 0 0 1-.53.19zm-2.57-1.5h2.26l8.38-8.38L19 5.05l-8.38 8.38zm10.45 5a.74.74 0 0 0-.75-.75h-18a.75.75 0 1 0 0 1.5h18a.75.75 0 0 0 .72-.77zM6 17.58h-.22c-1-.12-1.14-1.22-1.26-2 0-.11 0-.26-.07-.4a13 13 0 0 0-1.26 2 .74.74 0 0 1-1 .33.75.75 0 0 1-.33-1c1.6-3.15 2.52-3.12 2.81-3.12 1 0 1.2 1.15 1.33 2a6 6 0 0 0 .14.74 3.87 3.87 0 0 0 .76-.29.75.75 0 0 1 .66 1.35 4.3 4.3 0 0 1-1.56.39zm-1.21-2.76z',
    fill: color
  }));
};

exports.SignatureIcon = SignatureIcon;